import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav.component';
import {RouterModule, Routes} from "@angular/router";
import {NgbDropdown, NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";


@NgModule({
  declarations: [
    NavComponent
  ],
  imports: [
    CommonModule,
    NgbDropdownModule,
    RouterModule
  ],
  exports: [
    NavComponent,
    RouterModule,
  ],
})
export class NavModule { }
